import { styled, css } from '../components-v4/theme';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
`;

export const Block = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.base};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.base};
    width: 100%;
    background-color: ${theme.colors.white};
    border-radius: ${theme.radiuses.m};
  `}
`;
